/**
 * Автоматический импорт всех routes.js из '@/modules' с добавлением префикса
 * в виде названия папки модуля, конвертированного в kebab-case
 */
// import { checkRole } from '@/helpers/role';

import { ROLES } from '@/constants/roles';

const getModulesRoutes = (user) => {
  const routesModules = require.context('@/modules', true, /routes\.js$/);
  const registerRoutes = (modules) => modules.keys().reduce((acc, key) => {
    const importedRoutes = modules(key).default;
    if (importedRoutes) {
      return [...acc, ...importedRoutes];
    }
    return acc;
  }, []);
  let routes = [...registerRoutes(routesModules)];
  routes = routes.filter(({ path }) => !!path);

  const {
    isAuthenticated,
    isEventManager,
  } = user;

  if (isAuthenticated) {
    return routes
      .filter(({ meta }) => // Фильтр по ролям
        (!meta || !meta.accessList)
        || user.hasRoles(meta.accessList))

      .filter(({ meta }) => // Фильтр по правам (сейчас для event-менеджера используется)
        !meta?.permissionsList
        || !isEventManager
        || user.hasPermissions(meta.permissionsList));
  }
  return routes.filter((route) =>
    !route.meta
    || !route.meta.accessList
    || (route.meta.accessList || []).includes(ROLES.guest),
  );
};

export default getModulesRoutes;

// TODO: Make prefixed routes
// @/modules/Team/routes.js

// path: '/create'
// name: CreateTeam

// @/modules/UserManager/routes.js

// path: '/create'

// /user-manger/create
// /team/create
